import React from "react";
import { Bar } from "react-chartjs-2";

const VerticalBarChart = ({ graphLabels, graphValues }) => {
  const data = {
    labels: graphLabels,
    datasets: [
      {
        label: "No. of hits",
        data: graphValues,
        backgroundColor: "rgba(75,192,192,0.2)",
        borderColor: "rgba(75,192,192,1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: "Scores",
      },
    },
  };
  return (
    <div style={{ marginTop: "20px" }}>
      <Bar data={data} options={options} height={"90px"} />
    </div>
  );
};

export default VerticalBarChart;
